// extracted by mini-css-extract-plugin
module.exports = {"roleHistory":"RoleHistories_roleHistory__6h8T2","action":"RoleHistories_action__WA0XW","date":"RoleHistories_date__IM0bS","roleHistoryItem":"RoleHistories_roleHistoryItem__oOr_8"};